<div [id]="containerRef()" class="flex items-center assignee-container">
  @if (displayMode() === 'avatars') {
    <div class="flex items-center assignee-list">
      @if (croppedArray().length > 1) {
        @for (
          user of croppedArray();
          track user.id + '-' + $index;
          let index = $index
        ) {
          <lib-avatar
            [size]="''"
            [fullName]="user.name"
            [img]="user.image?.url ?? ''"
            [imgDimensions]="{
              width: imgDimensions().width,
              height: imgDimensions().height,
            }"
            [placeholderTextClass]="'text-primary-500 font-medium text-xs'"
            borderRadius="rounded-full" />
        }
      }

      <lib-avatar
        [label]="'+' + (userCount() - 3)"
        [size]="''"
        [imgDimensions]="{
          width: imgDimensions().width,
          height: imgDimensions().height,
        }"
        [hidden]="userCount() < 4"
        [placeholderTextClass]="'text-primary-500 font-medium text-xs'"
        borderRadius="rounded-full" />
    </div>
  }

  @if (displayMode() === 'underlined-text') {
    <div class="flex items-center gap-sm">
      <div
        class="flex items-center cursor-pointer text-primary-600 text-sm font-medium"
        (click)="toggleMenu($event)">
        <div
          class="bg-primary-50 rounded-full w-4xl h-4xl flex items-center justify-center">
          <lib-users-icon
            [iconClass]="'size-4'"
            stroke="var(--color-primary-600)" />
        </div>
        <span>
          @if (assigneeType().length > 0) {
            <span class="whitespace-nowrap ms-sm underline ps-x-sm">
              {{ userCount() }}
              {{ 'side_menu_assignee_view_screen_resources_label' | transloco }}
            </span>
          }
          <span class="whitespace-nowrap text-xs text-neutral-900">
            {{ 'request_details_assigned_to_step' | transloco }}
          </span>
        </span>
      </div>
    </div>
  }

  @if (croppedArray().length > 1 || displayMode() === 'underlined-text') {
    @if (displayMode() !== 'underlined-text') {
      <div class="flex items-center gap-sm cursor-pointer relative ms-sm">
        <button
          type="button"
          class="bg-transparent cursor-pointer flex"
          (click)="toggleMenu($event)">
          <lib-chevron-down-icon
            [iconClass]="
              'size-5 text-neutral-500 ' + (isMenuOpen() ? 'rotate-180' : '')
            " />
        </button>
      </div>
    }
  }
  @if (isMenuOpen()) {
    @if (displayMode() === 'avatars') {
      <div
        class="actions-container actions-container-rtl flex flex-col absolute bg-white shadow-xl rounded-lg gap-md py-2xl px-lg z-100 min-w-[22rem]"
        [class.list-position-top]="isListPositionTop()"
        [class.list-position-bottom]="!isListPositionTop()"
        [class.avatar-mode]="displayMode() === 'avatars' && isListPositionTop()"
        [class.underlined-text-mode]="
          displayMode() === 'underlined-text' && !isListPositionTop()
        "
        [class.ms-7xl]="displayMode() === 'underlined-text'"
        libClickOutSide
        (clickOutside)="isMenuOpen.set(false)">
        <div class="flex items-center justify-between w-full">
          <div class="flex items-center gap-sm">
            <div class="font-medium text-neutral-700 text-lg">
              {{ headerListLabel() }}
            </div>

            <lib-badge
              [label]="totalDropdownCount().toString()"
              [badgeClass]="'border-none text-xs font-semibold text-primary-500 bg-primary-50 px-sm'" />
          </div>

          @if (displayMode() === 'underlined-text' && showCloseButton()) {
            <button
              type="button"
              class="rounded border border-neutral-200 w-[1.5rem] h-[1.5rem] p-[.875rem] flex justify-center items-center"
              (click)="isMenuOpen.set(false)"
              aria-label="Close">
              <lib-close-icon [iconClass]="'size-5 text-neutral-700'" />
            </button>
          }
        </div>

        <div
          class="assignee-dropdown-container pe-sm w-full"
          (scroll)="onScroll($event)">
          @if (!userDropdownList().length && isDropdownLoading()) {
            <lib-loader [size]="'sm'" />
          } @else if (userDropdownList().length) {
            @for (
              user of userDropdownList();
              track user.id + '-' + $index;
              let index = $index
            ) {
              <div
                class="border-b border-neutral-200 w-full flex items-center gap-sm py-md">
                <lib-avatar
                  [fullName]="user.name ?? ''"
                  [img]="user.image?.url ?? ''"
                  [size]="''"
                  [imgDimensions]="{
                    width: imgDimensions().width,
                    height: imgDimensions().height,
                  }"
                  [placeholderTextClass]="'text-primary-500 font-medium text-xs'"
                  borderRadius="rounded-full" />

                <div class="flex-1 min-w-0">
                  <div
                    class="text-neutral-900 font-medium text-xs whitespace-nowrap max-w-[5.625rem]">
                    <span
                      libTrimTooltip
                      placement="top"
                      [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top request-details-tooltip cursor-pointer '"
                      [trimLength]="32"
                      [fullText]="user.name">
                    </span>
                  </div>

                  <div class="text-xs text-neutral-500 capitalize">
                    @if (
                      (assigneeType()[index] === RoleTypes.USER ||
                        assigneeType()[index] === RoleTypes.GROUP) &&
                      user.assigneeRole
                    ) {
                      {{ user.assigneeRole }}
                    } @else {
                      {{
                        'workflow_step_info_form_{' +
                          assigneeType()[index] +
                          '}_label' | transloco
                      }}
                    }
                  </div>
                </div>
              </div>
            }

            @if (isDropdownLoading()) {
              <div class="flex justify-center w-full">
                <lib-loader [size]="'sm'" />
              </div>
            }
          } @else {
            <div
              class="py-2xl px-lg flex flex-col items-center justify-center gap-md">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="57"
                height="56"
                viewBox="0 0 57 56"
                fill="none">
                <path
                  opacity="0.4"
                  d="M27.3327 48.9993C39.575 48.9993 49.4993 39.075 49.4993 26.8327C49.4993 14.5904 39.575 4.66602 27.3327 4.66602C15.0904 4.66602 5.16602 14.5904 5.16602 26.8327C5.16602 39.075 15.0904 48.9993 27.3327 48.9993Z"
                  fill="var(--color-neutral-300)" />
                <path
                  d="M50.2 51.3333C49.78 51.3333 49.36 51.17 49.0566 50.8666L44.7166 46.5266C44.0866 45.8966 44.0866 44.87 44.7166 44.2166C45.3466 43.5866 46.3733 43.5866 47.0266 44.2166L51.3666 48.5566C51.9966 49.1866 51.9966 50.2133 51.3666 50.8666C51.04 51.17 50.62 51.3333 50.2 51.3333Z"
                  fill="var(--color-primary-500)" />
                <path
                  d="M33.1667 29.0508H21.5C20.5433 29.0508 19.75 28.2574 19.75 27.3008C19.75 26.3441 20.5433 25.5508 21.5 25.5508H33.1667C34.1233 25.5508 34.9167 26.3441 34.9167 27.3008C34.9167 28.2574 34.1233 29.0508 33.1667 29.0508Z"
                  fill="var(--color-primary-500)" />
              </svg>
              {{ noSearchResultLabel() }}
            </div>
          }
        </div>
      </div>
    } @else {
      <div
        class="actions-container actions-container-rtl flex flex-col absolute bg-white shadow-xl rounded-lg gap-md py-2xl px-lg z-100 min-w-[22rem]"
        [class.list-position-top]="isListPositionTop()"
        [class.list-position-bottom]="!isListPositionTop()"
        [class.avatar-mode]="displayMode() === 'avatars' && isListPositionTop()"
        [class.underlined-text-mode]="
          displayMode() === 'underlined-text' && !isListPositionTop()
        "
        [class.ms-7xl]="displayMode() === 'underlined-text'">
        <div class="flex items-center justify-between w-full">
          <div class="flex items-center gap-sm">
            <div class="font-medium text-neutral-700 text-lg">
              {{ headerListLabel() }}
            </div>

            <lib-badge
              [label]="totalDropdownCount().toString()"
              [badgeClass]="'border-none text-xs font-semibold text-primary-500 bg-primary-50 px-sm'" />
          </div>

          @if (displayMode() === 'underlined-text' && showCloseButton()) {
            <button
              type="button"
              class="rounded border border-neutral-200 w-[1.5rem] h-[1.5rem] p-[.875rem] flex justify-center items-center"
              (click)="isMenuOpen.set(false)"
              aria-label="Close">
              <lib-close-icon [iconClass]="'size-5 text-neutral-700'" />
            </button>
          }
        </div>

        <div
          class="assignee-dropdown-container pe-sm w-full"
          (scroll)="onScroll($event)">
          @if (!userDropdownList().length && isDropdownLoading()) {
            <lib-loader [size]="'sm'" />
          } @else if (userDropdownList().length) {
            @for (
              user of userDropdownList();
              track user.id + '-' + $index;
              let index = $index
            ) {
              <div
                class="border-b border-neutral-200 w-full flex items-center gap-sm py-md">
                <lib-avatar
                  [fullName]="user.name ?? ''"
                  [img]="user.image?.url ?? ''"
                  [size]="''"
                  [imgDimensions]="{
                    width: imgDimensions().width,
                    height: imgDimensions().height,
                  }"
                  [placeholderTextClass]="'text-primary-500 font-medium text-xs'"
                  borderRadius="rounded-full" />

                <div class="flex-1 min-w-0">
                  <div class="flex items-center justify-between gap-xs">
                    <span
                      class="text-neutral-900 font-medium text-xs whitespace-nowrap"
                      libTrimTooltip
                      placement="top"
                      [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top request-details-tooltip cursor-pointer '"
                      [trimLength]="32"
                      [fullText]="user.name">
                    </span>
                    @if (
                      user.state?.value === Status.INACTIVE ||
                      user.state?.value === Status.DELETED
                    ) {
                      <div
                        class="bg-destructive-100 rounded-full px-sm py-xs shrink-0 -mt-sm">
                        <lib-badge
                          [label]="user.state.label"
                          [badgeClass]="'border-none text-xs font-medium text-destructive-700'" />
                      </div>
                    }
                  </div>

                  <div class="text-xs text-neutral-500 capitalize">
                    @if (
                      (assigneeType()[index] === RoleTypes.USER ||
                        assigneeType()[index] === RoleTypes.GROUP) &&
                      user.assigneeRole
                    ) {
                      {{ user.assigneeRole }}
                    } @else {
                      {{
                        'workflow_step_info_form_{' +
                          assigneeType()[index] +
                          '}_label' | transloco
                      }}
                    }
                  </div>
                </div>
              </div>
            }

            @if (isDropdownLoading()) {
              <div class="flex justify-center w-full">
                <lib-loader [size]="'sm'" />
              </div>
            }
          } @else {
            <div
              class="py-2xl px-lg flex flex-col items-center justify-center gap-md">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="57"
                height="56"
                viewBox="0 0 57 56"
                fill="none">
                <path
                  opacity="0.4"
                  d="M27.3327 48.9993C39.575 48.9993 49.4993 39.075 49.4993 26.8327C49.4993 14.5904 39.575 4.66602 27.3327 4.66602C15.0904 4.66602 5.16602 14.5904 5.16602 26.8327C5.16602 39.075 15.0904 48.9993 27.3327 48.9993Z"
                  fill="var(--color-neutral-300)" />
                <path
                  d="M50.2 51.3333C49.78 51.3333 49.36 51.17 49.0566 50.8666L44.7166 46.5266C44.0866 45.8966 44.0866 44.87 44.7166 44.2166C45.3466 43.5866 46.3733 43.5866 47.0266 44.2166L51.3666 48.5566C51.9966 49.1866 51.9966 50.2133 51.3666 50.8666C51.04 51.17 50.62 51.3333 50.2 51.3333Z"
                  fill="var(--color-primary-500)" />
                <path
                  d="M33.1667 29.0508H21.5C20.5433 29.0508 19.75 28.2574 19.75 27.3008C19.75 26.3441 20.5433 25.5508 21.5 25.5508H33.1667C34.1233 25.5508 34.9167 26.3441 34.9167 27.3008C34.9167 28.2574 34.1233 29.0508 33.1667 29.0508Z"
                  fill="var(--color-primary-500)" />
              </svg>
              {{ noSearchResultLabel() }}
            </div>
          }
        </div>
      </div>
    }
  }
</div>
